import { render, staticRenderFns } from "./footer-table.vue?vue&type=template&id=d862a3c6&"
import script from "./footer-table.vue?vue&type=script&lang=ts&"
export * from "./footer-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports